<template>
  <div
    class="marquee-image"
    :class="[
      cssClasses,
    ]"
    :style="[
      basicStyles,
      borderStyles,
      imageBorderRadiusStyles,
      boxShadowStyles,
      blurStyles,
    ]"
  >
    <!-- Your component's HTML template goes here -->
    <img
      :src="imageUrl"
      alt="Marquee Image"
      :data-test-image-optimized="imageMetaOptimizeApplied"
      @error="handleImageError"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ElementsMixins from '../../../mixins/elements-mixins';
import { buildImageUrl } from '../../../utils/useMedia';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  name: 'MarqueeImage',
  mixins: [ElementsMixins],
  data() {
    return {
      useFallback: false,
    };
  },
  computed: {
    ...mapGetters('graphicsTemplate', [
      'getElementValueByProp',
      'getDataValue',
    ]),
    borderTopLeftRadius() {
      return this.element?.borderTopLeftRadius ?? 0;
    },
    borderTopRightRadius() {
      return this.element?.borderTopRightRadius ?? 0;
    },
    borderBottomRightRadius() {
      return this.element?.borderBottomRightRadius ?? 0;
    },
    borderBottomLeftRadius() {
      return this.element?.borderBottomLeftRadius ?? 0;
    },
    mappedImage() {
      return this.isMapped('imageUrl') && this.getDataValue(this.id, 'imageUrl');
    },
    imageUrl: {
      get() {
        if (!this.useFallback && this.mappedImage) {
          return this.mappedImage;
        }

        // use "fallback" if there is an error
        const imageUrl = this.getElementValueByProp(this.id, 'imageUrl');
        if (!imageUrl) {
          return `${TGB_ASSETS_URL}/placeholders/placeholder-square.svg`;
        }

        const imageMeta = this.getElementValueByProp(this.id, 'imageMeta');

        return buildImageUrl(imageUrl, imageMeta);
      },
      set(v) {
        this.updateOneElementValue('imageUrl', v);
      },
    },
    imageBorderRadiusStyles() {
      return {
        borderRadius: `${this.borderTopLeftRadius}px ${this.borderTopRightRadius}px ${this.borderBottomRightRadius}px ${this.borderBottomLeftRadius}px`,
      };
    },
  },
  watch: {
    mappedImage() {
      this.useFallback = false;
    },
  },
  methods: {
    handleImageError() {
      this.useFallback = true;
    },
  },
};
</script>
